import React from "react";
import { Link, useLocation } from "react-router-dom";
import cn from "classnames";
import { SERVICES } from "../../content/siteContent";

const serviceMenuColumns = [
  ["secp-services", "pec-services", "fbr-services", "aedb-services"],
  [
    "boi-registration",
    "import-export-registration",
    "professional-tax-certificate",
    "income-tax-return",
  ],
  [
    "additional-services",
    "audit-report",
    "chamber-of-commerce",
    "pra-bra-srb-registration",
    "trademark-registration",
  ],
];

export const NavMenus = () => {
  const { pathname } = useLocation();

  const isActiveCn = (path) => (path === pathname ? "active" : "");
  const servicesBySlug = SERVICES.reduce((items, service) => {
    items[service.slug] = service;
    return items;
  }, {});

  return (
    <div className="navbar-wrap main-menu d-none d-lg-flex">
      <ul className="navigation">
        <li className={cn(isActiveCn("/"))}>
          <Link to="/">Home</Link>
        </li>

        <li
          className={cn("menu-item-has-children", {
            active: pathname.startsWith("/services"),
          })}
        >
          <a href="/#">Services</a>
          <ul className="sub-menu services-mega-menu">
            <li className={cn(isActiveCn("/services"))}>
              <Link to="/services">All Services</Link>
            </li>
            {serviceMenuColumns.map((column, columnIndex) => (
              <li className="service-menu-column" key={columnIndex}>
                <ul>
                  {column.map((slug) => {
                    const service = servicesBySlug[slug];

                    if (!service) {
                      return null;
                    }

                    return (
                      <li
                        key={service.slug}
                        className={cn(isActiveCn(`/services/${service.slug}`))}
                      >
                        <Link to={`/services/${service.slug}`}>
                          {service.navTitle}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </li>
            ))}
          </ul>
        </li>

        <li className={cn(isActiveCn("/about"))}>
          <Link to="/about">About Us</Link>
        </li>

        <li className={cn(isActiveCn("/blog") || pathname.startsWith("/blog/") ? "active" : "")}>
          <Link to="/blog">Blog</Link>
        </li>

        <li className={cn(isActiveCn("/privacy-policy"))}>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </li>

        <li className={cn(isActiveCn("/contact"))}>
          <Link to="/contact">Contact Us</Link>
        </li>
      </ul>
    </div>
  );
};
